/** Step 1 "Role". */
const wizJobEN = {
  wizJobTitle: 'Which role is this about?',
  wizJobSubtitle:
    'Paste the job ad or describe the role in a few sentences. SAIA builds the search and the messages from it.',
  wizJobDescriptionLabel: 'Job description',
  wizJobDescriptionPlaceholder:
    'e.g. Senior Backend Developer (m/f/d) in Munich, hybrid. 5+ years of Java and Spring Boot, experience with microservices. Fluent German.',
  wizJobLinkButton: 'Paste link to the ad',
  wizLinkTitle: 'Read job ad from a link',
  wizLinkHint: 'We read the text of the ad for you.',
  wizLinkInvalid: 'Please enter a valid link (https://…).',
  wizLinkReplaces: 'The text in the ad field will be replaced by the ad that is read.',
  wizLinkCancel: 'Cancel',
  wizLinkSubmit: 'Read ad',
  wizJobReadingUrl: 'Reading the ad …',
  wizJobReadUrlError: 'The ad could not be read.',
  wizJobCheckButton: 'Check ad with AI',
  wizJobChecking: 'SAIA is checking your job ad …',
  wizJobCheckError: 'The ad could not be checked right now.',
  wizJobAdTitle: 'Job ad: {{title}} · {{score}} of {{total}} points',
  wizJobLevel1: 'Too thin',
  wizJobLevel2: 'Could be better',
  wizJobLevel3: 'Good',
  wizJobLevel1Desc: 'SAIA will hardly find suitable candidates with this. Add the missing points.',
  wizJobLevel2Desc: 'Works, but with more details the search and the messages get more accurate.',
  wizJobLevel3Desc: 'Enough information for search, rating and messages.',
  wizJobFixAll: 'Add what is missing',
  wizJobStale: 'Details changed – check again',
  wizJobAddOne: 'Add',
  wizJobFillIn: 'Fill in',
  wizJobAdded: 'Added',
  wizJobSourceAi: 'Checked by SAIA (AI)',
  wizJobSourceHeuristic: 'AI not available – quick check',
  wizJobCheckPresent: 'Present.',
  wizJobCheckMissing: 'Missing in the ad.',
  wizJobNotSentHint:
    'The ad is not sent to the talents word for word – SAIA uses the ad and the additions as the basis for search, rating and messages.',
  wizJobExtrasLabel: 'Additions & optimisations',
  wizJobExtrasPlaceholder:
    'Extra facts about the role that are missing in the ad – e.g. benefits, requirements or special features. Suggestions from the AI check end up here.',
  wizJobExtrasHint:
    'Feeds into the AI check, search, rating and messages without changing the original ad. Only enter facts that are true.',
  wizJobTitleFieldLabel: 'Job title',
  wizJobTitleFieldPlaceholder: 'e.g. Senior Backend Developer (m/f/d)',
  wizJobTitleFieldHint:
    'Used for the job title in messages and search. Empty: SAIA derives it from the ad.',
  wizJobNameLabel: 'Campaign name',
  wizJobNamePlaceholder: 'e.g. Senior Backend Developer (m/f/d) – Munich',
  wizJobAccountLabel: 'Sender (LinkedIn account)',
  wizJobAccountPlaceholder: 'Choose account',
  wizJobSimilar: 'Filled a similar role before?',
  wizJobUseTemplate: 'Use an existing campaign as a template',
  wizJobCloneTitle: 'Use an existing campaign as a template',
  wizJobCloneIntro:
    'Briefing, rating criteria and approach of the chosen campaign are copied. If the template has no briefing, you need to describe the role again. You can adjust everything afterwards.',
  wizJobCloneSelect: 'Campaign',
  wizJobCloneSelectPlaceholder: 'Choose campaign',
  wizJobCloneContacts: 'Also copy candidates',
  wizJobCloneNone: 'There is no recruiting campaign yet that you could use as a template.',
  wizJobCloneLoadError: 'The campaigns could not be loaded.',
  wizJobCloneNameSuffix: '(copy)',
  wizJobCloneCancel: 'Cancel',
  wizJobCloneConfirm: 'Use as template',
  wizJobCloneError: 'The campaign could not be copied.',
};
export default wizJobEN;
